import { createSlice } from '@reduxjs/toolkit';

export const serviceSlice = createSlice({
    name: 'service',
    initialState: {
        modulo: null, // ['C', 'N', 'P', 'M]
        membresia: null,
        idCita: null,
        idReunionZoom: null,
        passwordReunionZoom: null,
        urlReunionZoom: null,
        origin: '',
        modulos: []
    },
    reducers: {
        setModules: (state, { payload }) => {
            state.modulos = payload;
        },
        clearModules: (state, { payload }) => {
            state.modulos = [];
        },
        setService: (state, { payload }) => {
            state.modulo = payload.modulo;
            state.membresia = payload.membresia;
            state.idCita = payload.idCita;
            state.idReunionZoom = payload.idReunionZoom;
            state.passwordReunionZoom = payload.passwordReunionZoom;
            state.urlReunionZoom = payload.urlReunionZoom;
            state.origin = payload.origin;
        },
        clearService: (state, { payload }) => {
            state.modulo = null;
            state.membresia = null;
            state.idCita = null;
            state.idReunionZoom = null;
            state.passwordReunionZoom = null;
            state.urlReunionZoom = null;
            state.origin = '';
        },
    }
});


// Action creators are generated for each case reducer function
export const { setService, clearService, setModules, clearModules } = serviceSlice.actions;